import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import Vue from "vue";

let logger = {
    debug: function (message) {
        console.debug(message);
    },
    info: function (message) {
        console.info(message)
    },
    warn: function (message) {
        if (message.includes('Session not sent due')) return;
        console.warn(message);
    },
    error: function (message) {
        console.error(message);
    }
};

Bugsnag.start({
    apiKey: import.meta.env.VITE_BUGSNAG_VUE_KEY,
    plugins: [new BugsnagPluginVue()],
    releaseStage: import.meta.env.VITE_APP_ENV,
    appVersion: import.meta.env.VITE_BUILD,
    enabledReleaseStages: ['production', 'staging'],

    // This should be enabled by default. Forcing to true.
    // https://docs.bugsnag.com/platforms/javascript/vue/configuration-options/#autodetecterrors
    autoDetectErrors: true,

    // Those should be enabled by default. Forcing to true.
    // https://docs.bugsnag.com/platforms/javascript/vue/configuration-options/#enablederrortypes
    enabledErrorTypes: {
        unhandledExceptions: true,
        unhandledRejections: true,
    },

    // This should be enabled by default. Forcing to true.
    // https://docs.bugsnag.com/platforms/javascript/vue/configuration-options/#trackinlinescripts
    trackInlineScripts: true,
    logger: logger
});

const bugsnagVue = Bugsnag.getPlugin('vue')
bugsnagVue.installVueErrorHandler(Vue);
